import { Colors } from './Colors'

export const TextContents = {
    popup: {
        text: "Dans cette dernière étape, replacez chaque procédure selon la situation de l'entreprise.",
    },
    consigne : {
        text : "Placez chaque procédure selon la situation de l'entreprise.",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    title : {
        text : "TRIBUNAUX DE COMMERCE",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique18\'>Étape 3</class>\nMESURES DE PRÉVENTION ET\nDE TRAITEMENT DES DIFFICULTÉS\nDES ENTREPRISES",
        config: { size: '18px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    
}

export const CartesInfos = [
    {
        titre: "Mandat ad hoc",
        zoneId: 0,
        trueId: 0,
        image: "mandat",
        corrections: [
            {
                ids: [1],
                autoCorrect: false,
                presque: true,
                texte: "Le mandat ad hoc est une procédure amiable et confidentielle adaptée à une entreprise qui n'est pas sur le point d'entrer en cessation des paiements. Retentez votre chance !"
            },
            {
                ids: [2, 3, 4],
                autoCorrect: false,
                presque: false,
                texte: "Le mandat ad hoc est une procédure amiable et confidentielle car l'entreprise continue d'honorer ses engagements avec ses autres partenaires. Retentez votre chance !"
            },
        ],
        correct: "Le mandat ad hoc est bien une procédure amiable et confidentielle adaptée à une entreprise qui continue d'honorer ses engagements avec ses autres partenaires et n'est pas en cessation des paiements.",
    },
    {
        titre: "Conciliation",
        zoneId: 1,
        trueId: 1,
        image: "conciliation",
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: true,
                texte: "La conciliation est  une procédure amiable et confidentielle adaptée à une entreprise qui se trouve sur le point d'entrer en cessation des paiements, ou l'est depuis moins de 45 jours. Retentez votre chance !"
            },
            {
                ids: [2,3,4],
                autoCorrect: false,
                presque: false,
                texte: "La conciliation est une procédure amiable et confidentielle car l'entreprise continue d'honorer ses engagements avec ses autres partenaires. Retentez votre chance !"
            },
            
        ],
        correct: "La conciliation est bien une procédure amiable et confidentielle adaptée à une entreprise qui continue d'honorer ses engagements avec ses autres partenaires et se trouve sur le point d'entrer en cessation des paiements ou l'est depuis moins de 45 jours.",
    },
    {
        titre: "Sauvegarde",
        zoneId: 2,
        trueId: 2,
        image: "planSauvegarde",
        corrections: [
            {
                ids: [3,4],
                autoCorrect: false,
                presque: true,
                texte: "La sauvegarde est une procédure collective adaptée à une entreprise qui n'est pas en cessation des paiements. Retentez votre chance !"
            },
            {
                ids: [0,1],
                autoCorrect: false,
                presque: false,
                texte: "La sauvegarde est une procédure collective consistant à geler, renégocier puis rembourser les dettes dans le cadre d'un plan de sauvegarde. Retentez votre chance !"
            },
            
        ],
        correct: "La sauvegarde est bien une procédure collective consistant à geler, renégocier puis rembourser les dettes dans le cadre d'un plan de sauvegarde afin d'éviter la cessation des paiements.",
    },
    {
        titre: "Redressement judiciaire\n<class=\'boldSmall\'>Plan de continuation</class>",
        zoneId: 3,
        trueId: 3,
        image: "planContinuation",
        corrections: [
            {
                ids: [2],
                autoCorrect: false,
                presque: true,
                texte: "Le redressement judiciaire avec plan de continuation est bien une procédure collective visant à rembourser les dettes, mais adaptée à une entreprise en cessation des paiements. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: true,
                texte: "Le redressement judiciaire avec plan de continuation est bien une procédure collective visant à rembourser les dettes, mais adaptée à une entreprise offrant des perspectives de redressement. Retentez votre chance !"
            },
            {
                ids: [0,1],
                autoCorrect: false,
                presque: false,
                texte: "Le redressement judiciaire avec plan de continuation est une procédure collective car elle nécessite de geler les dettes le temps de la procédure et d'alerter l'ensemble des créanciers. Retentez votre chance !"
            },
            
        ],
        correct: "Un plan de continuation mis en place dans le cadre d'un redressement judiciaire est bien une procédure collective consistant à geler, renégocier, puis rembourser les dettes, adapté à une entreprise en cessation des paiements mais offrant des perspectives de redressement.",
    },
    {
        titre: "Redressement judiciaire\n<class=\'boldSmall\'>Plan de cession</class>",
        zoneId: 3,
        trueId: 4,
        image: "planCession",
        corrections: [
            {
                ids: [2],
                autoCorrect: false,
                presque: true,
                texte: "Le redressement judiciaire avec plan de cession est bien une procédure collective visant à rembourser les dettes, mais adaptée à une entreprise déjà en cessation des paiements. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: true,
                texte: "Le redressement judiciaire avec plan de cession est bien une procédure collective visant à rembourser les dettes, mais adaptée à une entreprise offrant des perspectives de redressement. Retentez votre chance !"
            },
            {
                ids: [0,1],
                autoCorrect: false,
                presque: false,
                texte: "Le redressement judiciaire avec plan de cession est une procédure collective car elle nécessite de geler les dettes le temps de la procédure  et d'alerter l'ensemble des créanciers. Retentez votre chance !"
            },
            
        ],
        correct: "Un plan de cession totale ou partielle mis en place dans le cadre d'un redressement judiciaire est bien une procédure collective consistant à geler, renégocier, puis rembourser les dettes, adapté à une entreprise en cessation des paiements mais offrant des perspectives de redressement.",
    },
    {
        titre: "Liquidation judiciaire",
        zoneId: 4,
        trueId: 5,
        image: "liquidation",
        corrections: [
            {
                ids: [3],
                autoCorrect: false,
                presque: true,
                texte: "La liquidation judiciaire est une procédure collective prononcée à l'encontre d'une entreprise n'offrant pas de perspectives de redressement. Retentez votre chance !"
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: true,
                texte: "La liquidation judiciaire est une procédure collective prononcée à l'encontre d'une entreprise en cessation des paiements n'offrant pas de perspectives de redressement. Retentez votre chance !"
            },
            {
                ids: [0,1],
                autoCorrect: false,
                presque: false,
                texte: "La liquidation judiciaire est  une procédure collective car elle nécessite de geler les dettes le temps de la procédure et d'alerter l'ensemble des créanciers. Retentez votre chance !"
            },
            
        ],
        correct: "La liquidation judiciaire est bien une procédure collective, prononcée en l'absence de perspectives de redressement, visant à vendre les actifs, recouvrir les créances et rembourser les dettes qui peuvent l'être.",
    },
]

export const ZonesInfos = [
    {
        index: 1,
        zoneX: 1048,
        zoneY: 222,
        zoneId: 0,
        trueId: 0,
        image: "mandat",
    },
    {
        index: 2,
        zoneX: 1283,
        zoneY: 222,
        zoneId: 1,
        trueId: 1,
        image: "conciliation",
    },
    {
        index: 3,
        zoneX: 1175,
        zoneY: 572,
        zoneId: 2,
        trueId: 2,
        image: "planSauvegarde",
    },
    {
        index: 4,
        zoneX: 1395,
        zoneY: 572,
        zoneId: 3,
        trueId: 3,
        image: "planContinuation",
    },
    {
        index: 5,
        zoneX: 1546,
        zoneY: 630,
        zoneId: 3,
        trueId: 4,
        image: "planCession",
    },
    {
        index: 6,
        zoneX: 1760,
        zoneY: 572,
        zoneId: 4,
        trueId: 5,
        image: "liquidation",
    },
   
]